import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: sticky;
  top: 0;
  height: 60px;
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `0 ${theme.spacing(3)}`};
  background: ${({ theme }) => theme.colors.neutrals.white};
  z-index: 101;
  box-shadow: 0 -1px 0 0 ${({ theme }) => theme.colors.neutrals.grey8} inset;
  justify-content: space-between;
`;

export const ExtraMobileActionsWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    display: none;
  `}
`;

export const LogoWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  `}
`;

export const UserMenuWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    margin-left: -${theme.spacing(2.5)};
  `}
`;
